<template>
  <div class="touch-wrap" v-on:touchstart="onTouchStart($event)" v-on:touchend="onTouchEnd($event)" v-on:touchmove="onTouchMove($event)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      startX: 0
    }
  },
  props: {
    slideHandler: {
      type: Function,
      required: true
    }
  },
  methods: {
    onTouchStart: function (e) {
      // e.preventDefault()
      const touch = e.touches[0]
      this.startX = touch.screenX
    },
    onTouchEnd: function (e) {
      // e.preventDefault()
      const touch = e.changedTouches[0]
      if (Math.abs(touch.screenX - this.startX) > 50) {
        this.slideHandler(touch.screenX - this.startX)
      }
    },
    onTouchMove: function (e) {
      e.preventDefault()
      // console.log('touch move')
    }
  }
}
</script>

<style lang="scss" scoped>
.touch-wrap {
  width: 100%;
  height: 100%;
  touch-action: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Touch.vue